import React from 'react';
import { CopyIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import style from './NoPlansStub.scss';

export const NoActivePlansStub: React.FC = () => {
  return (
    <div className={style.noPlansStub}>
      <CopyIcon width={20} height={20} />
      <Text variant="md" className={style.stubTitle}>
        No plans yet
      </Text>
      <Text variant="sm" color={Color.GRAY}>
        Start by duplicating a Cairns Health plan. Customize it, save it as your own template, and it will show up here.
      </Text>
    </div>
  );
};

export const NoFoundPlansStub: React.FC = () => {
  return (
    <div className={style.noPlansStub}>
      <CopyIcon width={20} height={20} />
      <Text variant="md" className={style.stubTitle}>
        No plans found
      </Text>
    </div>
  );
};
